import Vue from "vue";
import VueRouter from "vue-router";

import HomePage from "../views/HomePage.vue";
import OurHomestays from "@/views/OurHomestays.vue";
import PropertyManagement from "@/views/PropertyManagement.vue";
import DesignBuild from "@/views/DesignBuild.vue";
import AboutUs from "@/views/AboutUs.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/homestays",
    name: "OurHomestays",
    component: OurHomestays,
  },
  {
    path: "/property-management",
    name: "PropertyManagement",
    component: PropertyManagement,
  },

  {
    path: "/design-build",
    name: "DesignBuild",
    component: DesignBuild,
  },
  {
    path: "/about-us",
    name: "AboutUs",
    component: AboutUs,
  },

  // {
  //   path: "/page-1",
  //   name: "Page1",
  //   component: Page1,
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {});

export default router;
